module.exports = __webpack_public_path__ + "media/images/emblems/Sainte-Croix-coat_of_arms-3104e0aad064af5a9548ccf9b2ee056c.svg";